import { MsaPrefix, SIdpPrefix, SecurityIdentifierType } from '../types/ResourceTenant.types';

// More details on AltSecId claim: https://aadwiki.windows-int.net/index.php?title=AltSecId_Types
// altSecId is in format SecurityIdentityType:IdentityProvider:Puid

export function processAltSecIdClaim(altSecIdClaim: string, puid: string | null) {
  let securityIdentityType = SecurityIdentifierType.OrgID;
  let identityProvider: string | null = null;

  // By default assign this value from the token claim of PUID
  // http://schemas.microsoft.com/identity/claims/puid
  let identifier: string | null = puid;
  const allowSocialIdpUsers = true; // TODO: Get this from configuration

  if (altSecIdClaim !== null && altSecIdClaim !== '') {
    const altSecIdClaimParts = altSecIdClaim.split(':');
    const isSocialIdpUser = altSecIdClaim.startsWith(SIdpPrefix, 0);

    if (altSecIdClaimParts.length >= 3) {
      securityIdentityType = altSecIdClaimParts[0] as SecurityIdentifierType;
      identityProvider = altSecIdClaimParts[1] === '' ? null : altSecIdClaimParts[1];
      identifier = altSecIdClaimParts[2];
    }

    if (altSecIdClaim.startsWith(MsaPrefix, 0)) {
      securityIdentityType = SecurityIdentifierType.LiveID;
    } else {
      if (allowSocialIdpUsers && isSocialIdpUser && altSecIdClaimParts.length > 2) {
        // User is a Org ID Social Idp account
        // sample altsecid 6:google.com:108917652332672870744
        // A guest user will be created inside the inviting tenant when invited social user accepts the invitation and
        // they will have PUID and it should be considered as OrgId user.
        // use the currentTenant's puid fetched directly from Puid claim
        identifier = puid;
      }
    }
  } else {
    securityIdentityType = SecurityIdentifierType.OrgID;
  }
  // Further processing or state updates can be done here
  return { securityIdentityType, identityProvider, identifier };
}
